import dayjs from 'dayjs'
import { cloneDeep } from 'lodash'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { isEN, useUser } from '@/store'
import { useStore } from 'vuex'
dayjs.extend(customParseFormat)
export const getJapanTime = (time: any, format?: any) => {
  if (time && time !== '-') {
    const defferZone = getDefferTime()
    return dayjs(time).add(defferZone, 'hour').format(format || 'YYYY-MM-DD HH:mm:ss')
  }
  return '-'
}
// 本地时间转服务器时间
export const getServiceTime = (time: any, format?: any) => {
  if (time && time !== '-') {
    const defferZone = getDefferTime()
    return dayjs(time).subtract(defferZone, 'hour').format(format || 'YYYY-MM-DD HH:mm:ss')
  }
  return '-'
}
// 服务器差额时间
export const getDefferTime = () => {
  // 日本站韩国站默认为1
  if (!isEN()) return 1
  const user = useUser()
  // 目前服务器时间为+8东八区时间，根据用户所在地的时区加减时间
  const defaultZone = 8
  const customerUtcTimeZone = user?.utcTimeZone ? Number(user?.utcTimeZone?.replace('UTC', '')) : (0 - new Date().getTimezoneOffset() / 60)
  const defferZone = customerUtcTimeZone - defaultZone
  return defferZone
}
export const setJapanTime = (time: any, format?: any) => time && time !== '-' ? getJapanTime(time, format) : '-'
export const isAxiosTime = (data?: any) => {
  if (!data) return data
  if (data instanceof FormData) {
    return data
  }
  const newData = cloneDeep(data)
  Object.entries(newData).forEach(([k, v]: [string, any]) => {
    if (dayjs(v, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
      newData[k] = getServiceTime(v, 'YYYY-MM-DD HH:mm:ss')
    }
    if (dayjs(v, 'YYYY-MM-DD HH:mm', true).isValid()) {
      newData[k] = getServiceTime(v, 'YYYY-MM-DD HH:mm')
    }
    if (dayjs(v, 'YYYY-MM-DD HH', true).isValid()) {
      newData[k] = getServiceTime(v, 'YYYY-MM-DD HH')
    }
  })
  return newData
}

export const setStartDateTime = (time: any) => time ? dayjs(time + '00:00:00').format('YYYY-MM-DD HH:mm:ss') : ''
export const setEndDateTime = (time: any) => time ? dayjs(time + '23:59:59').format('YYYY-MM-DD HH:mm:ss') : ''

const getStatus = (value: any, defaultValue: any, setDefaultValue: any) => value ? value === defaultValue ? setDefaultValue : value : setDefaultValue
export const setTabData = (value: any, setDefaultValue?: string) => getStatus(value, '', setDefaultValue ?? 'all')
export const getTabData = (value: any, setDefaultValue?: string) => getStatus(value, setDefaultValue ?? 'all', '')

export const isEmptyObj = (obj: any): boolean => !(obj && Object.keys(obj).length > 0)

export const setDefaultForm = (form: any, defaultForm: any) => isEmptyObj(form) ? defaultForm : form

export const clearForm = (form: { [x: string]: any; }) => {
  Object.keys(form).map(key => { form[key] = '' })
}

export const setNoEmptyForm = (form: { [x: string]: any; }) => {
  const newForm: any = {}
  Object.keys(form).forEach(e => {
    if (form[e] || form[e] === 0) newForm[e] = form[e]
  })
  return newForm
}

export const isEqualObj = (source: any, comparison: any) => {
  const _source = JSON.stringify({ ...source })
  const _comparison = JSON.stringify({ ...source, ...comparison })
  return _source === _comparison
}

export const getAreaTxt = (row: { area: any }, provinces: any) => {
  const t: any = (provinces || []).find((e: any) => e.intAreaId === row.area)
  return t?.label
}

export const getCityTxt = (row: { area: any; city: any }, provinces: any) => {
  const t: any = (provinces || []).find((e: any) => e.intAreaId === row.area)
  if (t) {
    const v = t.children.find((e: { intAreaId: any }) => e.intAreaId === row.city)
    return v?.label
  } else {
    return ''
  }
}

export const getTrueNumber = (num:string | number) => {
  const number = Number(num)
  return Math.round(number * 100) / 100
}

/**
 *
 * let a = {0:'a',1:'b'}
 * ->
 * {0:'a'}
 * filterObjectKey(a,1)
 */
export const filterObjectKey = (obj:any, value:any) => {
  return Object.keys(obj).reduce((o:any, k:any) => {
    if (k !== value) {
      o[k] = obj[k]
    }
    return o
  }, {})
}
// 根据时区计算服务器时间
export const getServiceTime2 = (time: any, format?: any) => {
  // 目前服务器时间为+8东八区时间，根据用户所在地的时区加减时间
  const defaultZone = 8
  const customerUtcTimeZone = (0 - new Date().getTimezoneOffset() / 60)
  const defferZone = customerUtcTimeZone - defaultZone
  if (time && time !== '-') {
    return dayjs(time).subtract(defferZone, 'hour').format(format || 'YYYY-MM-DD HH:mm:ss')
  }
  return '-'
}
